module.exports = __webpack_public_path__ + "img/nav.9010fdeb.png";